<template>
  <ol class="breadcrumb">
    <router-link
      tag="li"
      class="breadcrumb-item"
      :to="{
        name: 'projectSubstations',
        params: { projectCode: project.code }
      }"
      exact
    >
      <a>{{ project.name || project.code }}</a>
    </router-link>
    <router-link
      v-if="substation"
      tag="li"
      class="breadcrumb-item"
      :to="{
        name: 'substationDevices',
        params: {
          projectCode: project.code,
          substationCode: substation.code
        }
      }"
      exact
    >
      <a>{{ substation.name || substation.code }}</a>
    </router-link>
    <router-link
      v-if="visnetHub"
      class="breadcrumb-item breadcrumb-item--current router-link-exact-active"
      tag="li"
      :to="{
        name: 'ElectricalComponent',
        params: {
          projectCode: project.code,
          substationCode: substation.code,
          externalVisnetHubId: visnetHub.externalVisnetHubId
        }
      }"
      exact
    >
      <Icon name="chevron-right" />
      <a>{{ visnetHub.name || visnetHub.externalVisnetHubId }}</a>
    </router-link>
    <router-link
      v-if="guard1000"
      class="breadcrumb-item breadcrumb-item--current router-link-exact-active"
      tag="li"
      :to="{
        name: 'Guard1000PanelDefault',
        params: {
          projectCode: project.code,
          substationCode: substation.code,
          externalGuardId: guard1000.externalGuardId
        }
      }"
      exact
    >
      <Icon name="chevron-right" />
      <a>{{ guard1000.name || guard1000.externalGuardId }}</a>
    </router-link>
    <li v-if="agent && device" class="breadcrumb-item">
      {{ agent.name || agent.code }}
    </li>
    <li v-if="device" class="breadcrumb-item breadcrumb-item--current">
      <Icon name="chevron-right" />
      {{ deviceName(device) }}
    </li>
    <li v-if="!device && agent" class="breadcrumb-item breadcrumb-item--current">
      <Icon name="chevron-right" />
      {{ agent.name || agent.code }}
    </li>
  </ol>
</template>

<script>
import DeviceMethods from '@/components/mixins/device-methods';

export default {
  name: 'Breadcrumbs',
  mixins: [DeviceMethods],
  props: {
    project: Object,
    substation: Object,
    visnetHub: Object,
    agent: Object,
    device: Object,
    guard1000: Object
  }
};
</script>
